// extracted by mini-css-extract-plugin
    if(module.hot) {
      // 1791229017837
      var cssReload = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"publicPath":"../../","locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  